import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/captions.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";

import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import SavingsOutlinedIcon from "@mui/icons-material/SavingsOutlined";
import PersonPinCircleOutlinedIcon from "@mui/icons-material/PersonPinCircleOutlined";

import { Button, OverlayTrigger, Popover } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { Navigation, Pagination } from "swiper/modules";
import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  faArrowRightLong,
  faEnvelope,
  faMagnifyingGlass,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import {
  fetchProductDetailItem,
  fetchProductsDetail,
  fetchRelatedProductsAll,
} from "../actions/global";

import AsideHome from "../components/AsideHome";
import Captions from "yet-another-react-lightbox/plugins/captions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import HelmetSeo from "../components/Reusable/HelmetSeo";
import Lightbox from "yet-another-react-lightbox";
import ListProductsItem from "../components/ListProductsItem";
import Loader from "../components/Reusable/Loader";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Video from "yet-another-react-lightbox/plugins/video";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import PriceBox from "../components/Reusable/PriceBox";
import QtyInputProduct from "../components/Reusable/QtyInputProduct";

// Import Swiper React components

// Import Swiper styles

const popover = (
  <Popover id="popover-basic">
    <Popover.Body>
      <div>062/63-97-96</div>
      <div>062/20-86-84</div>
    </Popover.Body>
  </Popover>
);
const popoverMail = (
  <Popover id="popover-basic">
    <Popover.Body>
      <div>up.it.webshop@gmail.com</div>
    </Popover.Body>
  </Popover>
);

const ProductDetail = () => {
  const { sifra } = useParams();
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [closeOnBackdropClick, setCloseOnBackdropClick] = useState(true);

  const {
    dataProductDetailList,
    dataRelatedProductsList,
    loadingProductDetail,
  } = useSelector((state) => state.globalReducer);

  useEffect(() => {
    dispatch(fetchProductDetailItem(sifra));
  }, [sifra, dispatch]);

  const [mainImage, setMainImage] = useState("");

  //prvo ucitavanje
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "instant",
    });
  }, []);

  useEffect(() => {
    if (dataProductDetailList) {
      const firstProduct = dataProductDetailList;
      if (firstProduct.images && firstProduct.images.length > 0) {
        setMainImage(firstProduct?.images?.[0]);
      } else {
        setMainImage("/images/no-image-product.png");
      }
    }
  }, [dataProductDetailList]);

  useEffect(() => {
    if (dataProductDetailList) {
      const page = 0;
      const size = 6;
      const asc = false;
      const categoryId = dataProductDetailList.categoryId;
      const filters = [];
      dispatch(
        fetchRelatedProductsAll(filters, categoryId, { page, size, asc })
      );
    }
  }, [dataProductDetailList, dispatch]);

  return (
    <>
      <HelmetSeo
        title={`${
          dataProductDetailList && dataProductDetailList.name
        } | UP-IT Shop`}
        description={``}
        keywords={``}
      />

      {loadingProductDetail ? (
        <Loader />
      ) : (
        <>
          {dataProductDetailList && (
            <>
              <nav className="breadcrumb-nav container1">
                <ul className="breadcrumb bb-no">
                  <li>
                    <Link to="/">Pocetna -</Link>
                  </li>
                  {dataProductDetailList.categoryParentName && (
                    <li>
                      <Link
                        to={`/katalog/nadgrupa/${dataProductDetailList.categoryParentId}/`}
                      >
                        {dataProductDetailList.categoryParentName} -
                      </Link>
                    </li>
                  )}
                  {dataProductDetailList.categoryName && (
                    <li>
                      <Link
                        to={`/katalog/grupa/${dataProductDetailList.categoryId}/`}
                      >
                        {dataProductDetailList.categoryName} -
                      </Link>
                    </li>
                  )}
                  <li>
                    <b>{dataProductDetailList.name}</b>
                  </li>
                </ul>
              </nav>

              <div className="page-content product-detail-page-content">
                <div className="container1">
                  <div className="row gutter-lg">
                    <div className="main-content">
                      <div className="product product-single row">
                        <div className="col-md-6 mb-6">
                          <div className="product-gallery product-gallery-sticky">
                            <div className="swiper-container product-single-swiper swiper-theme nav-inner">
                              <div className="swiper-wrapper row cols-1 gutter-no">
                                <div className="swiper-slide2">
                                  <figure
                                    className="product-image product-image-custom-produc-detail"
                                    onClick={() => setOpen(true)}
                                  >
                                    <div className="zoom-image-icon-product-detail">
                                      <FontAwesomeIcon
                                        icon={faMagnifyingGlass}
                                        type="button"
                                      />
                                    </div>
                                    <img
                                      src={mainImage}
                                      data-zoom-image="https://www.uspon.rs/images/products/big/90821.webp"
                                      alt="UP IT"
                                      width="800"
                                      height="900"
                                    />
                                    <Lightbox
                                      open={open}
                                      close={() => setOpen(false)}
                                      slides={dataProductDetailList?.images?.map(
                                        (slika) => ({ src: slika })
                                      )}
                                      index={dataProductDetailList?.images?.indexOf(
                                        mainImage
                                      )}
                                      styles={{
                                        container: {
                                          backgroundColor: "rgba(0, 0, 0, .8)",
                                        },
                                      }}
                                      controller={{
                                        closeOnBackdropClick,
                                      }}
                                      plugins={[
                                        Captions,
                                        Fullscreen,
                                        Slideshow,
                                        Thumbnails,
                                        Video,
                                        Zoom,
                                      ]}
                                    />

                                    <div className="product-label-group">
                                      {dataProductDetailList.new == 1 && (
                                        <label className="product-label label-new">
                                          Novo
                                        </label>
                                      )}

                                      {dataProductDetailList.highlighted && (
                                        <label className="product-label label-new">
                                          Izdvojeno
                                        </label>
                                      )}
                                      {dataProductDetailList.trending && (
                                        <label className="product-label label-hot">
                                          Popularno
                                        </label>
                                      )}
                                      {dataProductDetailList.monthlySale && (
                                        <label className="product-label label-discount">
                                          % Mesečna akcija
                                        </label>
                                      )}
                                      {dataProductDetailList.sale && (
                                        <label className="product-label label-discount">
                                          % Akcija
                                        </label>
                                      )}
                                      {dataProductDetailList.bestSeller && (
                                        <label className="product-label label-hot">
                                          Najprodavanije
                                        </label>
                                      )}
                                      {dataProductDetailList.recommended && (
                                        <label className="product-label label-hot">
                                          Preporučujemo
                                        </label>
                                      )}
                                      {dataProductDetailList.fixPrice > 0 &&
                                        dataProductDetailList.fixPrice <
                                          dataProductDetailList.cashPrice && (
                                          <label className="product-label label-discount">
                                            % NA POPUSTU
                                          </label>
                                        )}
                                    </div>
                                  </figure>
                                </div>
                              </div>
                            </div>
                            <div className="product-thumbs-wrap swiper-container">
                              <div className="product-thumbs swiper-wrapper row gutter-sm">
                                <Swiper
                                  loop={true}
                                  modules={[Navigation, Pagination]}
                                  spaceBetween={30}
                                  slidesPerView={3}
                                  navigation
                                  pagination={{ clickable: true }}
                                  scrollbar={{ draggable: true }}
                                >
                                  {dataProductDetailList?.images?.map(
                                    (item, key) => (
                                      <SwiperSlide key={key}>
                                        <div
                                          key={key}
                                          className="product-thumb product-thumb-custom-product-detail"
                                          onClick={(e) => setMainImage(item)}
                                        >
                                          <img src={item} alt="Product Thumb" />
                                        </div>
                                      </SwiperSlide>
                                    )
                                  )}
                                </Swiper>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 sticky-sidebar-wrapper mb-2 mb-md-2">
                          <div
                            className="product-details sticky-sidebar"
                            data-sticky-options="{'minWidth': 767}"
                          >
                            <h1 className="product-title product-detail-title-custom">
                              {dataProductDetailList.name}
                            </h1>
                            <div className="product-bm-wrapper">
                              {/* <figure className="brand">
                        <img
                          src="assets/images/products/brand/brand-2.jpg"
                          alt="Brand"
                          width="105"
                          height="48"
                        />
                      </figure> */}
                              <div className="product-meta">
                                <ul className="shipping-helper">
                                  <li className="ok">
                                    <span itemprop="availability">
                                      Na stanju
                                    </span>
                                  </li>
                                </ul>
                                <div className="product-categories product-categories-detail-custom">
                                  <b>Brend</b>:{" "}
                                  <span>{dataProductDetailList.brand}</span>
                                </div>
                                <div className="product-categories product-categories-detail-custom">
                                  <b>Šifra artikla</b>:{" "}
                                  <span>{dataProductDetailList.code}</span>
                                </div>
                                {/* <div className="product-categories product-categories-detail-custom">
                                  <b>Nadgrupa</b>:{" "}
                                  <span>{dataProductDetailList.nadgrupa}</span>
                                </div>
                                <div className="product-categories product-categories-detail-custom">
                                  <b>Grupa</b>:{" "}
                                  <span>{dataProductDetailList.grupa}</span>
                                </div> */}
                                <div className="product-categories product-categories-detail-custom">
                                  <b>Lager</b>:{" "}
                                  <span>{dataProductDetailList.quantity}</span>
                                </div>
                              </div>
                            </div>

                            <div className="product-price product-price-holder-custom product-detail-price-custom">
                              <PriceBox
                                productDetail={true}
                                item={dataProductDetailList}
                              />
                            </div>

                            <div className="product-desc-detail-custom">
                              <ul>
                                <li>
                                  <ArticleOutlinedIcon />
                                  Dostava preko kurirskih službi{" "}
                                  <b>
                                    <a
                                      href="https://www.aks.rs/cenovnik/"
                                      target="_blank"
                                    >
                                      AKS
                                    </a>
                                  </b>{" "}
                                  i{" "}
                                  <b>
                                    <a
                                      href="https://bexexpress.rs/cenovnik"
                                      target="_blank"
                                    >
                                      BEX
                                    </a>
                                  </b>
                                  .
                                </li>
                                <li>
                                  <SavingsOutlinedIcon />
                                  Porudžbine iznad <b>15.000 RSD</b> ostvaruju
                                  besplatnu dostavu!
                                </li>
                                <li>
                                  <LocalShippingOutlinedIcon />
                                  Očekivani rok za isporuku od 2 do 5 radnih
                                  dana.
                                </li>
                                <li>
                                  <PersonPinCircleOutlinedIcon />
                                  Mogućnost preuzimanja naručene robe u nasem
                                  maloprodajnom objektu.
                                </li>
                              </ul>
                            </div>

                            <div className="fix-bottom product-sticky-content sticky-content">
                              <div className="product-form container">
                                <QtyInputProduct item={dataProductDetailList} />
                                {/* <div className="product-qty-form">
                                  <div className="input-group">
                                    <input
                                      className="quantity form-control"
                                      type="number"
                                      value={dataProductDetailList.kolicina}
                                      readOnly
                                    />
                                  </div>
                                </div> */}
                                {/* <div className="btn-item-call-action btn-item-call-action-mobile">
                                  <a
                                    href="tel:+38162208684"
                                    className="btn btn-primary btn-cart w-100"
                                  >
                                    <FontAwesomeIcon icon={faPhone} />
                                    <span>Pozovite za upit</span>
                                  </a>
                                </div>
                                <div className="btn-item-call-action btn-item-call-action-2 btn-item-call-action-mobile">
                                  <a
                                    href="mailto:up.it.webshop@gmail.com"
                                    className="btn btn-primary btn-cart w-100"
                                  >
                                    <FontAwesomeIcon icon={faEnvelope} />
                                    <span>Pišite nam</span>
                                  </a>
                                </div> */}
                                {/* <div className="btn-item-call-action btn-item-call-action-desktop">
                                  <OverlayTrigger
                                    trigger="click"
                                    placement="bottom"
                                    overlay={popover}
                                  >
                                    <Button className="btn btn-primary btn-cart w-100">
                                      <FontAwesomeIcon icon={faPhone} />
                                      <span>Pozovite za upit</span>
                                    </Button>
                                  </OverlayTrigger>
                                </div>
                                <div className="btn-item-call-action btn-item-call-action-2 btn-item-call-action-desktop">
                                  <OverlayTrigger
                                    trigger="click"
                                    placement="bottom"
                                    overlay={popoverMail}
                                  >
                                    <Button className="btn btn-primary btn-cart w-100">
                                      <FontAwesomeIcon icon={faEnvelope} />
                                      <span>Pišite nam</span>
                                    </Button>
                                  </OverlayTrigger>
                                </div> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <Tabs
                        defaultActiveKey="specifikacija"
                        id="uncontrolled-tab-example"
                      >
                        <Tab eventKey="specifikacija" title="Specifikacija">
                          <div
                            dangerouslySetInnerHTML={{
                              __html:
                                dataProductDetailList?.description?.replace(
                                  /<br\s*\/?>/g,
                                  ""
                                ),
                            }}
                          />
                        </Tab>
                        <Tab eventKey="deklaracija" title="Deklaracija">
                          <div
                            dangerouslySetInnerHTML={{
                              __html:
                                dataProductDetailList?.declaration?.replace(
                                  /<br\s*\/?>/g,
                                  ""
                                ),
                            }}
                          />
                        </Tab>
                      </Tabs>

                      <section className="related-product-section">
                        <div className="title-link-wrapper mb-4">
                          <h4 className="title">Povezani proizvodi</h4>
                          <Link
                            to={`/katalog/kategorija/${dataProductDetailList.categoryId}?page=0&asc=true`}
                            className="btn btn-dark btn-link btn-slide-right btn-icon-right"
                          >
                            Pogledajte sve proizvode{" "}
                            <FontAwesomeIcon icon={faArrowRightLong} />
                          </Link>
                        </div>
                        <div className="product-wrapper row cols-md-3 cols-sm-2 cols-1">
                          {dataRelatedProductsList &&
                            dataRelatedProductsList?.map((item, key) => {
                              return (
                                <div className="product-wrap" key={key}>
                                  <ListProductsItem item={item} />
                                </div>
                              );
                            })}
                        </div>
                      </section>
                    </div>
                    <AsideHome />
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      )}
    </>
  );
};

export default ProductDetail;
